<template>
  <div class="all_box">
    <div class="all_title">
      {{$t('base.shopBySports')}}
      <router-link :to="{path:'market?type=like'}" target="_blank">{{$t('base.seeAll')}}</router-link>
    </div>
    <div class="all_box">
      <div class="sports_box">
        <router-link :to="{path:'/market',query:{type:item.PropertyName,id:item.PropertyValue,f:item.FirstCategoryId,s:item.SecondCategoryId,t:item.ThirdCategoryId}}" v-for="(item,index) in sports" :key="index" target="_blank" :style='sportsWidth(sportsCount)'>
          <el-image class="sports_img" :src="item.IconUrl" fit="scale-down"></el-image>
          <span>{{ $store.state.lang != 'zh-tw'?item.EnName:item.ChName }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { CookiesCategory } from "@/api/public";
export default {
  name: 'footerNav',
  data() {
    return {
      sportsCount:12,
      sports: this.$enumInfo.PropertyList,
    }
  },
  mounted() {},
  created() {
    this.getMarketEntry()
  },
  methods: {
    getMarketEntry() {
      let that = this
      let fun = function(res) {
      //console.log("asares",res)
        that.sports = res
        that.sportsCount=res.length;
      }
      //console.log("asasasasa",that.sports)
      CookiesCategory('get', 'cardCategory', 'entry', fun)
    },
    sportsWidth(val){
      if(val>=16){
        return 'width:150px'
      }else if(val>=14){
        return 'width:170px'
      }else if(val>=12){
        return 'width:200px'
      }else if(val>=10){
        return 'width:240px;'
      }else{
        return 'width:240px;'
      }
    }

  },
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/css/home.css";

.sports_box .sports_img {
  width: 65px;
}

</style>



// WEBPACK FOOTER //
// src/components/entry.vue